import React, { useState } from 'react';
import { Form, Input, Button, notification } from 'antd';
import { useDispatch } from 'react-redux';
import { createComponent } from '../actions/componentActions';
import './Component.css';

const ComponentSection = ({ applicationId }) => {
  const dispatch = useDispatch();
  const [componentName, setComponentName] = useState('');

  const handleComponentSubmit = () => {
    if (!componentName.trim()) {
      notification.warning({
        message: 'Component Name Required',
        description: 'Please enter a component name.',
      });
      return;
    }

    const payload = { name: componentName };
    dispatch(createComponent({ applicationId, payload }))
      .then(() => {
        notification.success({
          message: 'Component Added Successfully',
          description: 'The component has been successfully created.',
        });
        setComponentName('');
      })
      .catch(() => {
        notification.error({
          message: 'Error Adding Component',
          description: 'There was an error adding the component. Please try again.',
        });
      });
  };

  return (
    <div className="component-section">
      <h4>Component</h4>

      <Form layout="vertical" onFinish={handleComponentSubmit}>
        <Form.Item label="Component Name" required>
          <Input
            value={componentName}
            onChange={(e) => setComponentName(e.target.value)}
            placeholder="Enter a new component name"
          />
        </Form.Item>

        <Button type="primary" htmlType="submit">
          Add Component
        </Button>
      </Form>
    </div>
  );
};

export default ComponentSection;
